export default "__VITE_ASSET__d7e9610f__"